export const wishdb = ["Good Job", "Bravo", "Way to go", "Great Work", "Nice"];
